/* eslint-disable react/display-name */
//@flow

// Vendors
import React, { lazy, Suspense } from 'react';
import { type ConnectedRouterProps } from 'connected-react-router';
import PAGE_TYPES from './pageTypes';

// Components
import { Loading } from '../components';

// Pages
import appPages from './apps';

const pageData = [
  ...appPages,
  {
    type: PAGE_TYPES.AUTH,
    name: 'AccountPage',
    component: lazy(() => import('./AccountPage/AccountPage')),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'AgencyPage',
    component: lazy(() => import('./AgencyPage/AgencyPage')),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'SelfServicePage',
    component: lazy(() => import('./SelfServicePage/SelfServicePage')),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'SelfServiceMetadata',
    component: lazy(() =>
      import(
        './SelfServicePage/SelfServiceSections/SelfServiceForms/SelfServiceMetadata'
      )
    ),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'SelfServiceMetadataSSO',
    component: lazy(() =>
      import(
        './SelfServicePage/SelfServiceSections/SelfServiceForms/SelfServiceMetadataSSO'
      )
    ),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'SelfServiceMetadataEdit',
    component: lazy(() =>
      import(
        './SelfServicePage/SelfServiceSections/SelfServiceForms/SelfServiceMetadataEdit'
      )
    ),
  },
  {
    type: PAGE_TYPES.PUBLIC,
    name: 'ForgotPasswordPage',
    component: lazy(() => import('./ForgotPasswordPage/ForgotPasswordPage')),
  },
  {
    type: PAGE_TYPES.PUBLIC,
    name: 'SetPasswordPage',
    component: lazy(() => import('./SetPasswordPage/SetPasswordPage')),
  },
  {
    type: PAGE_TYPES.PUBLIC,
    name: 'TokenError',
    component: lazy(() => import('./TokenError/TokenError')),
  },
  {
    type: PAGE_TYPES.PUBLIC,
    name: 'HomePage',
    componen: lazy(() => import('./HomePage/HomePage')),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'EmployeePage',
    component: lazy(() => import('./EmployeePage/EmployeePage')),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'EmployeeAgencyPage',
    component: lazy(() =>
      import(
        './EmployeePage/EmployeeSections/EmployeeAgencyPage/EmployeeAgencyPage'
      )
    ),
  },
  {
    type: PAGE_TYPES.AUTH,
    name: 'HistoryPage',
    component: lazy(() => import('./HistoryPage/HistoryPage')),
  },
  {
    name: 'NoMatchPage',
    component: lazy(() => import('./NoMatchPage/NoMatchPage')),
  },
  {
    type: PAGE_TYPES.PUBLIC_BASIC,
    name: 'LoginPage',
    component: lazy(() => import('./LoginPage/LoginPage')),
  },
  {
    type: PAGE_TYPES.AUTH_BASIC,
    name: 'OnboardingPage',
    component: lazy(() => import('./OnboardingPage/OnboardingPage')),
  },
  {
    type: PAGE_TYPES.PUBLIC_BASIC,
    name: 'ComingSoonPage',
    component: lazy(() => import('./ComingSoonPage/ComingSoonPage')),
  },
];

const getPages = (pageType: string) =>
  pageData
    .filter(page => !page.type || page.type === pageType)
    .reduce((acc, { name, component: PageComponent }) => {
      acc[name] = (props: ConnectedRouterProps) => (
        <Suspense fallback={<Loading style={{ position: 'relative' }} />}>
          <PageComponent {...props} />
        </Suspense>
      );
      return acc;
    }, {});

export default getPages;
